var PokemonsArray = [
    {
      "national_pokedex_number": 63,
      "name": "abra",
      "types": [
        "psychic"
      ],
      "baseStats": {
        "hp": 25,
        "attack": 20,
        "defense": 15,
        "speed": 90,
        "special": 105
      },
      "maxStats": {
        "maxHp": 254,
        "maxAtack": 152,
        "maxDefense": 141,
        "maxSpeed": 306,
      },
      "description": "Sleeps 18 hours a day. If it senses danger, it will teleport itself to safety even as it sleeps."
    },
    {
      "national_pokedex_number": 142,
      "name": "aerodactyl",
      "types": [
        "rock",
        "flying"
      ],
      "baseStats": {
        "hp": 80,
        "attack": 105,
        "defense": 65,
        "speed": 130,
        "special": 60
      },
      "maxStats": {
        "maxHp": 364,
        "maxAtack": 339,
        "maxDefense": 251,
        "maxSpeed": 364,
      },
      "description": "A Pokémon that was resurrected from the genes of an ancient dinosaur. With sharp fangs, it is very vicious."
    },
    {
      "national_pokedex_number": 65,
      "name": "alakazam",
      "types": [
        "psychic"
      ],
      "baseStats": {
        "hp": 55,
        "attack": 50,
        "defense": 45,
        "speed": 120,
        "special": 135
      },
      "maxStats": {
        "maxHp": 314,
        "maxAtack": 218,
        "maxDefense": 207,
        "maxSpeed": 372,
      },
      "description": "A Pokémon that can memorize anything. It never forgets what it learns—that's why this Pokémon is smart."
    },
    {
      "national_pokedex_number": 24,
      "name": "arbok",
      "types": [
        "poison"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 85,
        "defense": 69,
        "speed": 80,
        "special": 65
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 295,
        "maxDefense": 260,
        "maxSpeed": 284,
      },
      "description": "The frightening patterns on its belly have been studied. Six variations have been confirmed."
    },
    {
      "national_pokedex_number": 59,
      "name": "arcanine",
      "types": [
        "fire"
      ],
      "baseStats": {
        "hp": 90,
        "attack": 110,
        "defense": 80,
        "speed": 95,
        "special": 80
      },
      "maxStats": {
        "maxHp": 384,
        "maxAtack": 350,
        "maxDefense": 284,
        "maxSpeed": 317,
      },
      "description": "A Pokémon that has been admired since the past for its beauty. It runs agilely as if on wings."
    },
    {
      "national_pokedex_number": 144,
      "name": "articuno",
      "types": [
        "ice",
        "flying"
      ],
      "baseStats": {
        "hp": 90,
        "attack": 85,
        "defense": 100,
        "speed": 85,
        "special": 125
      },
      "maxStats": {
        "maxHp": 384,
        "maxAtack": 295,
        "maxDefense": 328,
        "maxSpeed": 295,
      },
      "description": "A legendary bird Pokémon. It freezes water that is contained in winter air and makes it snow."
    },
    {
      "national_pokedex_number": 15,
      "name": "beedrill",
      "types": [
        "bug",
        "poison"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 80,
        "defense": 40,
        "speed": 75,
        "special": 45
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 284,
        "maxDefense": 196,
        "maxSpeed": 273,
      },
      "description": "It has 3 poisonous stingers on its forelegs and its tail. They are used to jab its enemy repeatedly."
    },
    {
      "national_pokedex_number": 69,
      "name": "bellsprout",
      "types": [
        "grass",
        "poison"
      ],
      "baseStats": {
        "hp": 50,
        "attack": 75,
        "defense": 35,
        "speed": 40,
        "special": 70
      },
      "maxStats": {
        "maxHp": 304,
        "maxAtack": 273,
        "maxDefense": 185,
        "maxSpeed": 196,
      },
      "description": "Prefers hot and humid places. It ensnares tiny insects with its vines and devours them."
    },
    {
      "national_pokedex_number": 9,
      "name": "blastoise",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 79,
        "attack": 83,
        "defense": 100,
        "speed": 78,
        "special": 85
      },
      "maxStats": {
        "maxHp": 362,
        "maxAtack": 291,
        "maxDefense": 328,
        "maxSpeed": 280,
      },
      "description": "Once it takes aim at its enemy, it blasts out water with even more force than a fire hose."
    },
    {
      "national_pokedex_number": 1,
      "name": "bulbasaur",
      "types": [
        "grass",
        "poison"
      ],
      "baseStats": {
        "hp": 45,
        "attack": 49,
        "defense": 49,
        "speed": 45,
        "special": 65
      },
      "maxStats": {
        "maxHp": 294,
        "maxAtack": 216,
        "maxDefense": 216,
        "maxSpeed": 207,
      },
      "description": "It can go for days without eating a single morsel. In the bulb on its back, it stores energy."
    },
    {
      "national_pokedex_number": 12,
      "name": "butterfree",
      "types": [
        "bug",
        "flying"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 45,
        "defense": 50,
        "speed": 70,
        "special": 80
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 207,
        "maxDefense": 218,
        "maxSpeed": 262,
      },
      "description": "Its wings, covered with poisonous powders, repel water. This allows it to fly in the rain."
    },
    {
      "national_pokedex_number": 10,
      "name": "caterpie",
      "types": [
        "bug"
      ],
      "baseStats": {
        "hp": 45,
        "attack": 30,
        "defense": 35,
        "speed": 45,
        "special": 20
      },
      "maxStats": {
        "maxHp": 294,
        "maxAtack": 174,
        "maxDefense": 185,
        "maxSpeed": 207,
      },
      "description": "If you touch the feeler on top of its head, it will release a horrible stink to protect itself."
    },
    {
      "national_pokedex_number": 113,
      "name": "chansey",
      "types": [
        "normal"
      ],
      "baseStats": {
        "hp": 250,
        "attack": 5,
        "defense": 5,
        "speed": 50,
        "special": 105
      },
      "maxStats": {
        "maxHp": 704,
        "maxAtack": 119,
        "maxDefense": 119,
        "maxSpeed": 218,
      },
      "description": "A gentle and kind-hearted Pokémon that shares its nutritious eggs if it sees an injured Pokémon."
    },
    {
      "national_pokedex_number": 6,
      "name": "charizard",
      "types": [
        "fire",
        "flying"
      ],
      "baseStats": {
        "hp": 78,
        "attack": 84,
        "defense": 78,
        "speed": 100,
        "special": 85
      },
      "maxStats": {
        "maxHp": 360,
        "maxAtack": 293,
        "maxDefense": 280,
        "maxSpeed": 328,
      },
      "description": "When expelling a blast of super hot fire, the red flame at the tip of its tail burns more intensely."
    },
    {
      "national_pokedex_number": 4,
      "name": "charmander",
      "types": [
        "fire"
      ],
      "baseStats": {
        "hp": 39,
        "attack": 52,
        "defense": 43,
        "speed": 65,
        "special": 50
      },
      "maxStats": {
        "maxHp": 282,
        "maxAtack": 223,
        "maxDefense": 203,
        "maxSpeed": 251,
      },
      "description": "The flame at the tip of its tail makes a sound as it burns. You can only hear it in quiet places."
    },
    {
      "national_pokedex_number": 5,
      "name": "charmeleon",
      "types": [
        "fire"
      ],
      "baseStats": {
        "hp": 58,
        "attack": 64,
        "defense": 58,
        "speed": 80,
        "special": 65
      },
      "maxStats": {
        "maxHp": 320,
        "maxAtack": 249,
        "maxDefense": 236,
        "maxSpeed": 284,
      },
      "description": "Tough fights could excite this Pokémon. When excited, it may blow out bluish-white flames."
    },
    {
      "national_pokedex_number": 36,
      "name": "clefable",
      "types": [
        "fairy"
      ],
      "baseStats": {
        "hp": 95,
        "attack": 70,
        "defense": 73,
        "speed": 60,
        "special": 85
      },
      "maxStats": {
        "maxHp": 394,
        "maxAtack": 262,
        "maxDefense": 269,
        "maxSpeed": 240,
      },
      "description": "They appear to be very protective of their own world. It is a kind of fairy, rarely seen by people."
    },
    {
      "national_pokedex_number": 35,
      "name": "clefairy",
      "types": [
        "fairy"
      ],
      "baseStats": {
        "hp": 70,
        "attack": 45,
        "defense": 48,
        "speed": 35,
        "special": 60
      },
      "maxStats": {
        "maxHp": 344,
        "maxAtack": 207,
        "maxDefense": 214,
        "maxSpeed": 185,
      },
      "description": "Adored for their cute looks and playfulness. They are thought to be rare, as they do not appear often."
    },
    {
      "national_pokedex_number": 91,
      "name": "cloyster",
      "types": [
        "water",
        "ice"
      ],
      "baseStats": {
        "hp": 50,
        "attack": 95,
        "defense": 180,
        "speed": 70,
        "special": 85
      },
      "maxStats": {
        "maxHp": 304,
        "maxAtack": 317,
        "maxDefense": 504,
        "maxSpeed": 262,
      },
      "description": "For protection, it uses its harder-than-diamonds shell. It also shoots spikes from the shell."
    },
    {
      "national_pokedex_number": 104,
      "name": "cubone",
      "types": [
        "ground"
      ],
      "baseStats": {
        "hp": 50,
        "attack": 50,
        "defense": 95,
        "speed": 35,
        "special": 40
      },
      "maxStats": {
        "maxHp": 304,
        "maxAtack": 218,
        "maxDefense": 317,
        "maxSpeed": 185,
      },
      "description": "Wears the skull of its deceased mother. Its cries echo inside the skull and come out as a sad melody."
    },
    {
      "national_pokedex_number": 87,
      "name": "dewgong",
      "types": [
        "water",
        "ice"
      ],
      "baseStats": {
        "hp": 90,
        "attack": 70,
        "defense": 80,
        "speed": 70,
        "special": 95
      },
      "maxStats": {
        "maxHp": 384,
        "maxAtack": 262,
        "maxDefense": 284,
        "maxSpeed": 262,
      },
      "description": "Its entire body is a snowy-white. Unharmed by even intense cold, it swims powerfully in icy waters."
    },
    {
      "national_pokedex_number": 50,
      "name": "diglett",
      "types": [
        "ground"
      ],
      "baseStats": {
        "hp": 10,
        "attack": 55,
        "defense": 25,
        "speed": 95,
        "special": 45
      },
      "maxStats": {
        "maxHp": 224,
        "maxAtack": 229,
        "maxDefense": 163,
        "maxSpeed": 317,
      },
      "description": "It prefers dark places. It spends most of its time underground, though it may pop up in caves."
    },
    {
      "national_pokedex_number": 132,
      "name": "ditto",
      "types": [
        "normal"
      ],
      "baseStats": {
        "hp": 48,
        "attack": 48,
        "defense": 48,
        "speed": 48,
        "special": 48
      },
      "maxStats": {
        "maxHp": 300,
        "maxAtack": 214,
        "maxDefense": 214,
        "maxSpeed": 314,
      },
      "description": "When it spots an enemy, its body transforms into an almost perfect copy of its opponent."
    },
    {
      "national_pokedex_number": 85,
      "name": "dodrio",
      "types": [
        "normal",
        "flying"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 110,
        "defense": 70,
        "speed": 100,
        "special": 60
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 350,
        "maxDefense": 262,
        "maxSpeed": 328,
      },
      "description": "Uses its three brains to execute complex plans. While two heads sleep, one head stays awake."
    },
    {
      "national_pokedex_number": 84,
      "name": "doduo",
      "types": [
        "normal",
        "flying"
      ],
      "baseStats": {
        "hp": 35,
        "attack": 85,
        "defense": 45,
        "speed": 75,
        "special": 35
      },
      "maxStats": {
        "maxHp": 274,
        "maxAtack": 295,
        "maxDefense": 207,
        "maxSpeed": 273,
      },
      "description": "Its short wings make flying difficult. Instead, this Pokémon runs at high speed on developed legs."
    },
    {
      "national_pokedex_number": 148,
      "name": "dragonair",
      "types": [
        "dragon"
      ],
      "baseStats": {
        "hp": 61,
        "attack": 84,
        "defense": 65,
        "speed": 70,
        "special": 70
      },
      "maxStats": {
        "maxHp": 326,
        "maxAtack": 293,
        "maxDefense": 251,
        "maxSpeed": 262,
      },
      "description": "According to a witness, its body was surrounded by a strange aura that gave it a mystical look."
    },
    {
      "national_pokedex_number": 149,
      "name": "dragonite",
      "types": [
        "dragon",
        "flying"
      ],
      "baseStats": {
        "hp": 91,
        "attack": 134,
        "defense": 95,
        "speed": 80,
        "special": 100
      },
      "maxStats": {
        "maxHp": 386,
        "maxAtack": 403,
        "maxDefense": 317,
        "maxSpeed": 284,
      },
      "description": "It is said that this Pokémon lives somewhere in the sea and that it flies. However, it is only a rumor."
    },
    {
      "national_pokedex_number": 147,
      "name": "dratini",
      "types": [
        "dragon"
      ],
      "baseStats": {
        "hp": 41,
        "attack": 64,
        "defense": 45,
        "speed": 50,
        "special": 50
      },
      "maxStats": {
        "maxHp": 286,
        "maxAtack": 249,
        "maxDefense": 207,
        "maxSpeed": 218,
      },
      "description": "The existence of this mythical Pokémon was only recently confirmed by a fisherman who caught one."
    },
    {
      "national_pokedex_number": 96,
      "name": "drowzee",
      "types": [
        "psychic"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 48,
        "defense": 45,
        "speed": 42,
        "special": 90
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 214,
        "maxDefense": 207,
        "maxSpeed": 201,
      },
      "description": "If you sleep by it all the time, it will sometimes show you dreams it has eaten in the past."
    },
    {
      "national_pokedex_number": 51,
      "name": "dugtrio",
      "types": [
        "ground"
      ],
      "baseStats": {
        "hp": 35,
        "attack": 80,
        "defense": 50,
        "speed": 120,
        "special": 70
      },
      "maxStats": {
        "maxHp": 274,
        "maxAtack": 284,
        "maxDefense": 218,
        "maxSpeed": 372,
      },
      "description": "A team of triplets that can burrow over 60 MPH. Due to this, some people think it's an earthquake."
    },
    {
      "national_pokedex_number": 133,
      "name": "eevee",
      "types": [
        "normal"
      ],
      "baseStats": {
        "hp": 55,
        "attack": 55,
        "defense": 50,
        "speed": 55,
        "special": 65
      },
      "maxStats": {
        "maxHp": 314,
        "maxAtack": 229,
        "maxDefense": 318,
        "maxSpeed": 229,
      },
      "description": "Its genetic code is unstable, so it could evolve in a variety of ways. There are only a few alive."
    },
    {
      "national_pokedex_number": 23,
      "name": "ekans",
      "types": [
        "poison"
      ],
      "baseStats": {
        "hp": 35,
        "attack": 60,
        "defense": 44,
        "speed": 55,
        "special": 40
      },
      "maxStats": {
        "maxHp": 274,
        "maxAtack": 240,
        "maxDefense": 205,
        "maxSpeed": 229,
      },
      "description": "The older it gets, the longer it grows. At night, it wraps its long body around tree branches to rest."
    },
    {
      "national_pokedex_number": 125,
      "name": "electabuzz",
      "types": [
        "electric"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 83,
        "defense": 57,
        "speed": 105,
        "special": 85
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 291,
        "maxDefense": 234,
        "maxSpeed": 339,
      },
      "description": "If a major power outage occurs, it is certain that this Pokémon has eaten electricity at a power plant."
    },
    {
      "national_pokedex_number": 101,
      "name": "electrode",
      "types": [
        "electric"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 50,
        "defense": 70,
        "speed": 140,
        "special": 80
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 218,
        "maxDefense": 262,
        "maxSpeed": 416,
      },
      "description": "Stores electrical energy inside its body. Even the slightest shock could trigger a huge explosion."
    },
    {
      "national_pokedex_number": 102,
      "name": "exeggcute",
      "types": [
        "grass",
        "psychic"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 40,
        "defense": 80,
        "speed": 40,
        "special": 60
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 196,
        "maxDefense": 284,
        "maxSpeed": 196,
      },
      "description": "The heads attract each other and spin around. There must be 6 heads for it to maintain balance."
    },
    {
      "national_pokedex_number": 103,
      "name": "exeggutor",
      "types": [
        "grass",
        "psychic"
      ],
      "baseStats": {
        "hp": 95,
        "attack": 95,
        "defense": 85,
        "speed": 55,
        "special": 125
      },
      "maxStats": {
        "maxHp": 394,
        "maxAtack": 317,
        "maxDefense": 295,
        "maxSpeed": 229,
      },
      "description": "Its cries are very noisy. This is because each of the three heads thinks about whatever it likes."
    },
    {
      "national_pokedex_number": 83,
      "name": "farfetch'd",
      "types": [
        "normal",
        "flying"
      ],
      "baseStats": {
        "hp": 52,
        "attack": 65,
        "defense": 55,
        "speed": 60,
        "special": 58
      },
      "maxStats": {
        "maxHp": 308,
        "maxAtack": 251,
        "maxDefense": 229,
        "maxSpeed": 240,
      },
      "description": "Lives where reedy plants grow. They are rarely seen, so it's thought their numbers are decreasing."
    },
    {
      "national_pokedex_number": 22,
      "name": "fearow",
      "types": [
        "normal",
        "flying"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 90,
        "defense": 65,
        "speed": 100,
        "special": 61
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 306,
        "maxDefense": 251,
        "maxSpeed": 328,
      },
      "description": "A Pokémon that dates back many years. If it senses danger, it flies high and away, instantly."
    },
    {
      "national_pokedex_number": 136,
      "name": "flareon",
      "types": [
        "fire"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 130,
        "defense": 60,
        "speed": 65,
        "special": 110
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 394,
        "maxDefense": 240,
        "maxSpeed": 251,
      },
      "description": "It has a flame chamber inside its body. It inhales, then blows out fire that is over 3,000F degrees."
    },
    {
      "national_pokedex_number": 92,
      "name": "gastly",
      "types": [
        "ghost",
        "poison"
      ],
      "baseStats": {
        "hp": 30,
        "attack": 35,
        "defense": 30,
        "speed": 80,
        "special": 100
      },
      "maxStats": {
        "maxHp": 264,
        "maxAtack": 185,
        "maxDefense": 174,
        "maxSpeed": 284,
      },
      "description": "Said to appear in decrepit, deserted buildings. It has no real shape as it appears to be made of a gas."
    },
    {
      "national_pokedex_number": 94,
      "name": "gengar",
      "types": [
        "ghost",
        "poison"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 65,
        "defense": 60,
        "speed": 110,
        "special": 130
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 251,
        "maxDefense": 240,
        "maxSpeed": 350,
      },
      "description": "A Gengar is close by if you feel a sudden chill. It may be trying to lay a curse on you."
    },
    {
      "national_pokedex_number": 74,
      "name": "geodude",
      "types": [
        "rock",
        "ground"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 80,
        "defense": 100,
        "speed": 20,
        "special": 30
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 284,
        "maxDefense": 328,
        "maxSpeed": 152,
      },
      "description": "Commonly found near mountain trails, etc. If you step on one by accident, it gets angry."
    },
    {
      "national_pokedex_number": 44,
      "name": "gloom",
      "types": [
        "grass",
        "poison"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 65,
        "defense": 70,
        "speed": 40,
        "special": 85
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 251,
        "maxDefense": 262,
        "maxSpeed": 196,
      },
      "description": "Smells incredibly foul! However, around 1 out of 1,000 people enjoy sniffing its nose-bending stink."
    },
    {
      "national_pokedex_number": 42,
      "name": "golbat",
      "types": [
        "poison",
        "flying"
      ],
      "baseStats": {
        "hp": 75,
        "attack": 80,
        "defense": 70,
        "speed": 90,
        "special": 75
      },
      "maxStats": {
        "maxHp": 354,
        "maxAtack": 284,
        "maxDefense": 262,
        "maxSpeed": 306,
      },
      "description": "It attacks in a stealthy manner, without warning. Its sharp fangs are used to bite and suck blood."
    },
    {
      "national_pokedex_number": 118,
      "name": "goldeen",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 45,
        "attack": 67,
        "defense": 60,
        "speed": 63,
        "special": 50
      },
      "maxStats": {
        "maxHp": 294,
        "maxAtack": 256,
        "maxDefense": 240,
        "maxSpeed": 247,
      },
      "description": "When it is time for them to lay eggs, they can be seen swimming up rivers and falls in large groups."
    },
    {
      "national_pokedex_number": 55,
      "name": "golduck",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 80,
        "attack": 82,
        "defense": 78,
        "speed": 85,
        "special": 80
      },
      "maxStats": {
        "maxHp": 364,
        "maxAtack": 289,
        "maxDefense": 280,
        "maxSpeed": 295,
      },
      "description": "Its slim and long limbs end in broad flippers. They are used for swimming gracefully in lakes."
    },
    {
      "national_pokedex_number": 76,
      "name": "golem",
      "types": [
        "rock",
        "ground"
      ],
      "baseStats": {
        "hp": 80,
        "attack": 110,
        "defense": 130,
        "speed": 45,
        "special": 55
      },
      "maxStats": {
        "maxHp": 364,
        "maxAtack": 350,
        "maxDefense": 394,
        "maxSpeed": 207,
      },
      "description": "Once it sheds its skin, its body turns tender and whitish. Its hide hardens when it's exposed to air."
    },
    {
      "national_pokedex_number": 75,
      "name": "graveler",
      "types": [
        "rock",
        "ground"
      ],
      "baseStats": {
        "hp": 55,
        "attack": 95,
        "defense": 115,
        "speed": 35,
        "special": 45
      },
      "maxStats": {
        "maxHp": 314,
        "maxAtack": 317,
        "maxDefense": 361,
        "maxSpeed": 185,
      },
      "description": "Often seen rolling down mountain trails. Obstacles are just things to roll straight over, not avoid."
    },
    {
      "national_pokedex_number": 88,
      "name": "grimer",
      "types": [
        "poison"
      ],
      "baseStats": {
        "hp": 80,
        "attack": 80,
        "defense": 50,
        "speed": 25,
        "special": 40
      },
      "maxStats": {
        "maxHp": 364,
        "maxAtack": 284,
        "maxDefense": 218,
        "maxSpeed": 163,
      },
      "description": "Made of hardened sludge. It smells too putrid to touch. Even weeds won't grow in its path."
    },
    {
      "national_pokedex_number": 58,
      "name": "growlithe",
      "types": [
        "fire"
      ],
      "baseStats": {
        "hp": 55,
        "attack": 70,
        "defense": 45,
        "speed": 60,
        "special": 50
      },
      "maxStats": {
        "maxHp": 314,
        "maxAtack": 262,
        "maxDefense": 207,
        "maxSpeed": 240,
      },
      "description": "A Pokémon with a friendly nature. However, it will bark fiercely at anything invading its territory."
    },
    {
      "national_pokedex_number": 130,
      "name": "gyarados",
      "types": [
        "water",
        "flying"
      ],
      "baseStats": {
        "hp": 95,
        "attack": 125,
        "defense": 79,
        "speed": 81,
        "special": 100
      },
      "maxStats": {
        "maxHp": 394,
        "maxAtack": 383,
        "maxDefense": 282,
        "maxSpeed": 287,
      },
      "description": "Brutally vicious and enormously destructive. Known for totally destroying cities in ancient times."
    },
    {
      "national_pokedex_number": 93,
      "name": "haunter",
      "types": [
        "ghost",
        "poison"
      ],
      "baseStats": {
        "hp": 45,
        "attack": 50,
        "defense": 45,
        "speed": 95,
        "special": 115
      },
      "maxStats": {
        "maxHp": 294,
        "maxAtack": 218,
        "maxDefense": 207,
        "maxSpeed": 317,
      },
      "description": "By licking, it saps the victim's life. It causes shaking that won't stop until the victim's demise."
    },
    {
      "national_pokedex_number": 107,
      "name": "hitmonchan",
      "types": [
        "fighting"
      ],
      "baseStats": {
        "hp": 50,
        "attack": 105,
        "defense": 79,
        "speed": 76,
        "special": 35
      },
      "maxStats": {
        "maxHp": 304,
        "maxAtack": 339,
        "maxDefense": 282,
        "maxSpeed": 276,
      },
      "description": "Punches in corkscrew fashion. It can punch its way through a concrete wall in the same way as a drill."
    },
    {
      "national_pokedex_number": 106,
      "name": "hitmonlee",
      "types": [
        "fighting"
      ],
      "baseStats": {
        "hp": 50,
        "attack": 120,
        "defense": 53,
        "speed": 87,
        "special": 35
      },
      "maxStats": {
        "maxHp": 304,
        "maxAtack": 372,
        "maxDefense": 225,
        "maxSpeed": 300,
      },
      "description": "When kicking, the sole of its foot turns as hard as a diamond on impact and destroys its enemy."
    },
    {
      "national_pokedex_number": 116,
      "name": "horsea",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 30,
        "attack": 40,
        "defense": 70,
        "speed": 60,
        "special": 70
      },
      "maxStats": {
        "maxHp": 264,
        "maxAtack": 196,
        "maxDefense": 262,
        "maxSpeed": 240,
      },
      "description": "If it senses any danger, it will vigorously spray water or a special type of ink from its mouth."
    },
    {
      "national_pokedex_number": 97,
      "name": "hypno",
      "types": [
        "psychic"
      ],
      "baseStats": {
        "hp": 85,
        "attack": 73,
        "defense": 70,
        "speed": 67,
        "special": 115
      },
      "maxStats": {
        "maxHp": 374,
        "maxAtack": 269,
        "maxDefense": 262,
        "maxSpeed": 256,
      },
      "description": "Avoid eye contact if you come across one. It will try to put you to sleep by using its pendulum."
    },
    {
      "national_pokedex_number": 2,
      "name": "ivysaur",
      "types": [
        "grass",
        "poison"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 62,
        "defense": 63,
        "speed": 60,
        "special": 80
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 245,
        "maxDefense": 247,
        "maxSpeed": 240,
      },
      "description": "The bulb on its back grows by drawing energy. It gives off an aroma when it is ready to bloom"
    },
    {
      "national_pokedex_number": 39,
      "name": "jigglypuff",
      "types": [
        "normal",
        "fairy"
      ],
      "baseStats": {
        "hp": 115,
        "attack": 45,
        "defense": 20,
        "speed": 20,
        "special": 25
      },
      "maxStats": {
        "maxHp": 434,
        "maxAtack": 207,
        "maxDefense": 152,
        "maxSpeed": 152,
      },
      "description": "Uses its alluring eyes to enrapture its foe. It then sings a pleasing melody that lulls the foe to sleep."
    },
    {
      "national_pokedex_number": 135,
      "name": "jolteon",
      "types": [
        "electric"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 65,
        "defense": 60,
        "speed": 130,
        "special": 110
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 251,
        "maxDefense": 240,
        "maxSpeed": 394,
      },
      "description": "A sensitive Pokémon that easily becomes sad or angry. Every time its mood changes, it charges power."
    },
    {
      "national_pokedex_number": 124,
      "name": "jynx",
      "types": [
        "ice",
        "psychic"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 50,
        "defense": 35,
        "speed": 95,
        "special": 95
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 218,
        "maxDefense": 185,
        "maxSpeed": 317,
      },
      "description": "Appears to move to a rhythm of its own, as if it were dancing. It wiggles its hips as it walks."
    },
    {
      "national_pokedex_number": 140,
      "name": "kabuto",
      "types": [
        "rock",
        "water"
      ],
      "baseStats": {
        "hp": 30,
        "attack": 80,
        "defense": 90,
        "speed": 55,
        "special": 45
      },
      "maxStats": {
        "maxHp": 264,
        "maxAtack": 284,
        "maxDefense": 306,
        "maxSpeed": 229,
      },
      "description": "A Pokémon that was recovered from a fossil. It uses the eyes on its back while hiding on the sea floor."
    },
    {
      "national_pokedex_number": 141,
      "name": "kabutops",
      "types": [
        "rock",
        "water"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 115,
        "defense": 105,
        "speed": 80,
        "special": 70
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 361,
        "maxDefense": 339,
        "maxSpeed": 284,
      },
      "description": "A slim and fast swimmer. It slices its prey with its sharp sickles and drinks the body fluids."
    },
    {
      "national_pokedex_number": 64,
      "name": "kadabra",
      "types": [
        "psychic"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 35,
        "defense": 30,
        "speed": 105,
        "special": 120
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 185,
        "maxDefense": 174,
        "maxSpeed": 339,
      },
      "description": "Many odd things happen if this Pokémon is close by. For example, it makes clocks run backwards."
    },
    {
      "national_pokedex_number": 14,
      "name": "kakuna",
      "types": [
        "bug",
        "poison"
      ],
      "baseStats": {
        "hp": 45,
        "attack": 25,
        "defense": 50,
        "speed": 35,
        "special": 25
      },
      "maxStats": {
        "maxHp": 294,
        "maxAtack": 163,
        "maxDefense": 218,
        "maxSpeed": 185,
      },
      "description": "Able to move only slightly. When endangered, it may stick out its stinger and poison its enemy."
    },
    {
      "national_pokedex_number": 115,
      "name": "kangaskhan",
      "types": [
        "normal"
      ],
      "baseStats": {
        "hp": 105,
        "attack": 95,
        "defense": 80,
        "speed": 90,
        "special": 40
      },
      "maxStats": {
        "maxHp": 414,
        "maxAtack": 317,
        "maxDefense": 284,
        "maxSpeed": 306,
      },
      "description": "Raises its young in its belly pouch. Won't run from any fight to keep its young protected."
    },
    {
      "national_pokedex_number": 99,
      "name": "kingler",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 55,
        "attack": 130,
        "defense": 115,
        "speed": 75,
        "special": 50
      },
      "maxStats": {
        "maxHp": 314,
        "maxAtack": 394,
        "maxDefense": 361,
        "maxSpeed": 273,
      },
      "description": "One claw grew massively and as hard as steel. It has 10,000-HP strength. However, it is too heavy."
    },
    {
      "national_pokedex_number": 109,
      "name": "koffing",
      "types": [
        "poison"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 65,
        "defense": 95,
        "speed": 35,
        "special": 60
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 251,
        "maxDefense": 317,
        "maxSpeed": 185,
      },
      "description": "In hot places, its internal gases could expand and explode without any warning. Be very careful!"
    },
    {
      "national_pokedex_number": 98,
      "name": "krabby",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 30,
        "attack": 105,
        "defense": 90,
        "speed": 50,
        "special": 25
      },
      "maxStats": {
        "maxHp": 264,
        "maxAtack": 339,
        "maxDefense": 306,
        "maxSpeed": 218,
      },
      "description": "Its pincers are superb weapons. They sometimes break off during battle, but they grow back fast."
    },
    {
      "national_pokedex_number": 131,
      "name": "lapras",
      "types": [
        "water",
        "ice"
      ],
      "baseStats": {
        "hp": 130,
        "attack": 85,
        "defense": 80,
        "speed": 60,
        "special": 95
      },
      "maxStats": {
        "maxHp": 464,
        "maxAtack": 295,
        "maxDefense": 284,
        "maxSpeed": 240,
      },
      "description": "A gentle soul that can read the minds of people. It can ferry people across the sea on its back."
    },
    {
      "national_pokedex_number": 108,
      "name": "lickitung",
      "types": [
        "normal"
      ],
      "baseStats": {
        "hp": 90,
        "attack": 55,
        "defense": 75,
        "speed": 30,
        "special": 60
      },
      "maxStats": {
        "maxHp": 384,
        "maxAtack": 229,
        "maxDefense": 273,
        "maxSpeed": 174,
      },
      "description": "Its tongue spans almost 7 feet and moves more freely than its forelegs. Its licks can cause paralysis."
    },
    {
      "national_pokedex_number": 68,
      "name": "machamp",
      "types": [
        "fighting"
      ],
      "baseStats": {
        "hp": 90,
        "attack": 130,
        "defense": 80,
        "speed": 55,
        "special": 65
      },
      "maxStats": {
        "maxHp": 384,
        "maxAtack": 394,
        "maxDefense": 284,
        "maxSpeed": 229,
      },
      "description": "One arm alone can move mountains. Using all four arms, this Pokémon fires off awesome punches."
    },
    {
      "national_pokedex_number": 67,
      "name": "machoke",
      "types": [
        "fighting"
      ],
      "baseStats": {
        "hp": 80,
        "attack": 100,
        "defense": 70,
        "speed": 45,
        "special": 50
      },
      "maxStats": {
        "maxHp": 364,
        "maxAtack": 328,
        "maxDefense": 262,
        "maxSpeed": 207,
      },
      "description": "The belt around its waist holds back its energy. Without it, this Pokémon would be unstoppable."
    },
    {
      "national_pokedex_number": 66,
      "name": "machop",
      "types": [
        "fighting"
      ],
      "baseStats": {
        "hp": 70,
        "attack": 80,
        "defense": 50,
        "speed": 35,
        "special": 35
      },
      "maxStats": {
        "maxHp": 344,
        "maxAtack": 284,
        "maxDefense": 218,
        "maxSpeed": 185,
      },
      "description": "Very powerful in spite of its small size. Its mastery of many types of martial arts makes it very tough."
    },
    {
      "national_pokedex_number": 129,
      "name": "magikarp",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 20,
        "attack": 10,
        "defense": 55,
        "speed": 80,
        "special": 20
      },
      "maxStats": {
        "maxHp": 244,
        "maxAtack": 130,
        "maxDefense": 229,
        "maxSpeed": 284,
      },
      "description": "Famous for being very unreliable. It can be found swimming in seas, lakes, rivers and shallow puddles."
    },
    {
      "national_pokedex_number": 126,
      "name": "magmar",
      "types": [
        "fire"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 95,
        "defense": 57,
        "speed": 93,
        "special": 85
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 317,
        "maxDefense": 234,
        "maxSpeed": 313,
      },
      "description": "Born in an active volcano. Its body is always cloaked in flames, so it looks like a big ball of fire."
    },
    {
      "national_pokedex_number": 81,
      "name": "magnemite",
      "types": [
        "electric",
        "steel"
      ],
      "baseStats": {
        "hp": 25,
        "attack": 35,
        "defense": 70,
        "speed": 45,
        "special": 95
      },
      "maxStats": {
        "maxHp": 254,
        "maxAtack": 185,
        "maxDefense": 262,
        "maxSpeed": 207,
      },
      "description": "It is born with the ability to defy gravity. It floats in air on powerful electromagnetic waves."
    },
    {
      "national_pokedex_number": 82,
      "name": "magneton",
      "types": [
        "electric",
        "steel"
      ],
      "baseStats": {
        "hp": 50,
        "attack": 60,
        "defense": 95,
        "speed": 70,
        "special": 120
      },
      "maxStats": {
        "maxHp": 304,
        "maxAtack": 240,
        "maxDefense": 317,
        "maxSpeed": 262,
      },
      "description": "Generates strange radio signals. It raises the temperature by 3.6F degrees within 3,300 feet."
    },
    {
      "national_pokedex_number": 56,
      "name": "mankey",
      "types": [
        "fighting"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 80,
        "defense": 35,
        "speed": 70,
        "special": 35
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 284,
        "maxDefense": 185,
        "maxSpeed": 262,
      },
      "description": "An agile Pokémon that lives in trees. It angers easily and will not hesitate to attack anything."
    },
    {
      "national_pokedex_number": 105,
      "name": "marowak",
      "types": [
        "ground"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 80,
        "defense": 110,
        "speed": 45,
        "special": 50
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 284,
        "maxDefense": 350,
        "maxSpeed": 207,
      },
      "description": "Small and weak, this Pokémon is adept with its Bone Club. It has grown more vicious over the ages."
    },
    {
      "national_pokedex_number": 52,
      "name": "meowth",
      "types": [
        "normal"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 45,
        "defense": 35,
        "speed": 90,
        "special": 40
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 207,
        "maxDefense": 185,
        "maxSpeed": 306,
      },
      "description": "Appears to be more active at night. It loves round and shiny things. It can't stop from picking them up."
    },
    {
      "national_pokedex_number": 11,
      "name": "metapod",
      "types": [
        "bug"
      ],
      "baseStats": {
        "hp": 50,
        "attack": 20,
        "defense": 55,
        "speed": 30,
        "special": 25
      },
      "maxStats": {
        "maxHp": 304,
        "maxAtack": 152,
        "maxDefense": 229,
        "maxSpeed": 174,
      },
      "description": "Hardens its shell to protect itself. However, a large impact may cause it to pop out of its shell."
    },
    {
      "national_pokedex_number": 151,
      "name": "mew",
      "types": [
        "psychic"
      ],
      "baseStats": {
        "hp": 100,
        "attack": 100,
        "defense": 100,
        "speed": 100,
        "special": 100
      },
      "maxStats": {
        "maxHp": 404,
        "maxAtack": 328,
        "maxDefense": 328,
        "maxSpeed": 328,
      },
      "description": "When viewed through a microscope, this Pokémon's short, fine, delicate hair can be seen."
    },
    {
      "national_pokedex_number": 150,
      "name": "mewtwo",
      "types": [
        "psychic"
      ],
      "baseStats": {
        "hp": 106,
        "attack": 110,
        "defense": 90,
        "speed": 130,
        "special": 154
      },
      "maxStats": {
        "maxHp": 416,
        "maxAtack": 350,
        "maxDefense": 306,
        "maxSpeed": 394,
      },
      "description": "It was created by a scientist after years of horrific gene splicing and DNA engineering experiments."
    },
    {
      "national_pokedex_number": 146,
      "name": "moltres",
      "types": [
        "fire",
        "flying"
      ],
      "baseStats": {
        "hp": 90,
        "attack": 100,
        "defense": 90,
        "speed": 90,
        "special": 125
      },
      "maxStats": {
        "maxHp": 384,
        "maxAtack": 328,
        "maxDefense": 306,
        "maxSpeed": 306,
      },
      "description": "A legendary bird Pokémon. As it flaps its blazing wings, even the night sky will turn red."
    },
    {
      "national_pokedex_number": 122,
      "name": "mr. mime",
      "types": [
        "psychic",
        "fairy"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 45,
        "defense": 65,
        "speed": 90,
        "special": 100
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 207,
        "maxDefense": 251,
        "maxSpeed": 306,
      },
      "description": "Always practices its pantomime act. It makes enemies believe something exists that really doesn't."
    },
    {
      "national_pokedex_number": 89,
      "name": "muk",
      "types": [
        "poison"
      ],
      "baseStats": {
        "hp": 105,
        "attack": 105,
        "defense": 75,
        "speed": 50,
        "special": 65
      },
      "maxStats": {
        "maxHp": 414,
        "maxAtack": 339,
        "maxDefense": 273,
        "maxSpeed": 218,
      },
      "description": "Smells so awful, it can cause fainting. Through degeneration, it lost its sense of smell."
    },
    {
      "national_pokedex_number": 34,
      "name": "nidoking",
      "types": [
        "poison",
        "ground"
      ],
      "baseStats": {
        "hp": 81,
        "attack": 92,
        "defense": 77,
        "speed": 85,
        "special": 75
      },
      "maxStats": {
        "maxHp": 366,
        "maxAtack": 311,
        "maxDefense": 278,
        "maxSpeed": 295,
      },
      "description": "Its steel-like hide adds to its powerful tackle. Its horns are so hard, they can pierce a diamond."
    },
    {
      "national_pokedex_number": 31,
      "name": "nidoqueen",
      "types": [
        "poison",
        "ground"
      ],
      "baseStats": {
        "hp": 90,
        "attack": 82,
        "defense": 87,
        "speed": 76,
        "special": 75
      },
      "maxStats": {
        "maxHp": 384,
        "maxAtack": 289,
        "maxDefense": 300,
        "maxSpeed": 276,
      },
      "description": "A pokemon wild, with a thirst of blood and hungry for human flesh, also cute."
    },
    {
      "national_pokedex_number": 29,
      "name": "nidoran♀",
      "types": [
        "poison"
      ],
      "baseStats": {
        "hp": 55,
        "attack": 47,
        "defense": 52,
        "speed": 41,
        "special": 40
      },
      "maxStats": {
        "maxHp": 314,
        "maxAtack": 212,
        "maxDefense": 223,
        "maxSpeed": 199,
      },
      "description": "A mild-mannered Pokémon that does not like to fight. Beware, its small horns secrete venom."
    },
    {
      "national_pokedex_number": 32,
      "name": "nidoran♂",
      "types": [
        "poison"
      ],
      "baseStats": {
        "hp": 46,
        "attack": 57,
        "defense": 40,
        "speed": 50,
        "special": 40
      },
      "maxStats": {
        "maxHp": 296,
        "maxAtack": 234,
        "maxDefense": 196,
        "maxSpeed": 218,
      },
      "description": "Its large ears are always kept upright. If it senses danger, it will attack with a poisonous sting."
    },
    {
      "national_pokedex_number": 30,
      "name": "nidorina",
      "types": [
        "poison"
      ],
      "baseStats": {
        "hp": 70,
        "attack": 62,
        "defense": 67,
        "speed": 56,
        "special": 55
      },
      "maxStats": {
        "maxHp": 344,
        "maxAtack": 245,
        "maxDefense": 256,
        "maxSpeed": 232,
      },
      "description": "When resting deep in its burrow, its thorns always retract. This is proof that it is relaxed."
    },
    {
      "national_pokedex_number": 33,
      "name": "nidorino",
      "types": [
        "poison"
      ],
      "baseStats": {
        "hp": 61,
        "attack": 72,
        "defense": 57,
        "speed": 65,
        "special": 55
      },
      "maxStats": {
        "maxHp": 326,
        "maxAtack": 267,
        "maxDefense": 234,
        "maxSpeed": 251,
      },
      "description": "Its horns contain venom. If they are stabbed into an enemy, the impact makes the poison leak out."
    },
    {
      "national_pokedex_number": 38,
      "name": "ninetales",
      "types": [
        "fire"
      ],
      "baseStats": {
        "hp": 73,
        "attack": 76,
        "defense": 75,
        "speed": 100,
        "special": 100
      },
      "maxStats": {
        "maxHp": 350,
        "maxAtack": 276,
        "maxDefense": 273,
        "maxSpeed": 328,
      },
      "description": "According to an enduring legend, 9 noble saints were united and reincarnated as this Pokémon."
    },
    {
      "national_pokedex_number": 43,
      "name": "oddish",
      "types": [
        "grass",
        "poison"
      ],
      "baseStats": {
        "hp": 45,
        "attack": 50,
        "defense": 55,
        "speed": 30,
        "special": 75
      },
      "maxStats": {
        "maxHp": 294,
        "maxAtack": 218,
        "maxDefense": 229,
        "maxSpeed": 174,
      },
      "description": "It may be mistaken for a clump of weeds. If you try to yank it out of the ground, it shrieks horribly."
    },
    {
      "national_pokedex_number": 138,
      "name": "omanyte",
      "types": [
        "rock",
        "water"
      ],
      "baseStats": {
        "hp": 35,
        "attack": 40,
        "defense": 100,
        "speed": 35,
        "special": 90
      },
      "maxStats": {
        "maxHp": 274,
        "maxAtack": 196,
        "maxDefense": 328,
        "maxSpeed": 185,
      },
      "description": "An ancient Pokémon that was recovered from a fossil. It swims by cleverly twisting its 10 tentacles about."
    },
    {
      "national_pokedex_number": 139,
      "name": "omastar",
      "types": [
        "rock",
        "water"
      ],
      "baseStats": {
        "hp": 70,
        "attack": 60,
        "defense": 125,
        "speed": 55,
        "special": 115
      },
      "maxStats": {
        "maxHp": 344,
        "maxAtack": 240,
        "maxDefense": 383,
        "maxSpeed": 229,
      },
      "description": "Sharp beaks ring its mouth. Its shell was too big for it to move freely, so it became extinct."
    },
    {
      "national_pokedex_number": 95,
      "name": "onix",
      "types": [
        "rock",
        "ground"
      ],
      "baseStats": {
        "hp": 35,
        "attack": 45,
        "defense": 160,
        "speed": 70,
        "special": 30
      },
      "maxStats": {
        "maxHp": 274,
        "maxAtack": 207,
        "maxDefense": 460,
        "maxSpeed": 262,
      },
      "description": "Burrows at high speed in search of food. The tunnels it leaves are used as homes by Diglett"
    },
    {
      "national_pokedex_number": 46,
      "name": "paras",
      "types": [
        "bug",
        "grass"
      ],
      "baseStats": {
        "hp": 35,
        "attack": 70,
        "defense": 55,
        "speed": 25,
        "special": 55
      },
      "maxStats": {
        "maxHp": 274,
        "maxAtack": 262,
        "maxDefense": 229,
        "maxSpeed": 163,
      },
      "description": "Burrows under the ground to gnaw on tree roots. The mushrooms on its back absorb most of the nutrition."
    },
    {
      "national_pokedex_number": 47,
      "name": "parasect",
      "types": [
        "bug",
        "grass"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 95,
        "defense": 80,
        "speed": 30,
        "special": 80
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 317,
        "maxDefense": 284,
        "maxSpeed": 174,
      },
      "description": "The bug host is drained of energy by the mushrooms on its back. They appear to do all the thinking."
    },
    {
      "national_pokedex_number": 53,
      "name": "persian",
      "types": [
        "normal"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 70,
        "defense": 60,
        "speed": 115,
        "special": 65
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 262,
        "maxDefense": 240,
        "maxSpeed": 361,
      },
      "description": "The gem in its forehead glows on its own! It walks with all the grace and elegance of a proud queen."
    },
    {
      "national_pokedex_number": 18,
      "name": "pidgeot",
      "types": [
        "normal",
        "flying"
      ],
      "baseStats": {
        "hp": 83,
        "attack": 80,
        "defense": 75,
        "speed": 91,
        "special": 70
      },
      "maxStats": {
        "maxHp": 370,
        "maxAtack": 284,
        "maxDefense": 273,
        "maxSpeed": 309,
      },
      "description": "This Pokémon flies at Mach 2 speed, seeking prey. Its large talons are feared as wicked weapons."
    },
    {
      "national_pokedex_number": 17,
      "name": "pidgeotto",
      "types": [
        "normal",
        "flying"
      ],
      "baseStats": {
        "hp": 63,
        "attack": 60,
        "defense": 55,
        "speed": 71,
        "special": 50
      },
      "maxStats": {
        "maxHp": 330,
        "maxAtack": 240,
        "maxDefense": 229,
        "maxSpeed": 265,
      },
      "description": "This Pokémon is full of vitality. It constantly flies around its large territory in search of prey."
    },
    {
      "national_pokedex_number": 16,
      "name": "pidgey",
      "types": [
        "normal",
        "flying"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 45,
        "defense": 40,
        "speed": 56,
        "special": 35
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 207,
        "maxDefense": 196,
        "maxSpeed": 232,
      },
      "description": "Very docile. If attacked, it will often kick up sand to protect itself rather than fight back."
    },
    {
      "national_pokedex_number": 25,
      "name": "pikachu",
      "types": [
        "electric"
      ],
      "baseStats": {
        "hp": 35,
        "attack": 55,
        "defense": 30,
        "speed": 90,
        "special": 50
      },
      "maxStats": {
        "maxHp": 274,
        "maxAtack": 229,
        "maxDefense": 174,
        "maxSpeed": 306,
      },
      "description": "It keeps its tail raised to monitor its surroundings. If you yank its tail, it will try to bite you."
    },
    {
      "national_pokedex_number": 127,
      "name": "pinsir",
      "types": [
        "bug"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 125,
        "defense": 100,
        "speed": 85,
        "special": 55
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 383,
        "maxDefense": 328,
        "maxSpeed": 295,
      },
      "description": "Grips its prey in its pincers and squeezes hard! It can't move if it's cold, so it lives in warm places."
    },
    {
      "national_pokedex_number": 60,
      "name": "poliwag",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 50,
        "defense": 40,
        "speed": 90,
        "special": 40
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 218,
        "maxDefense": 196,
        "maxSpeed": 306,
      },
      "description": "The direction of the spiral on the belly differs by area. It is more adept at swimming than walking."
    },
    {
      "national_pokedex_number": 61,
      "name": "poliwhirl",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 65,
        "defense": 65,
        "speed": 90,
        "special": 50
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 251,
        "maxDefense": 251,
        "maxSpeed": 306,
      },
      "description": "Under attack, it uses its belly spiral to put the foe to sleep. It then makes its escape."
    },
    {
      "national_pokedex_number": 62,
      "name": "poliwrath",
      "types": [
        "water",
        "fighting"
      ],
      "baseStats": {
        "hp": 90,
        "attack": 85,
        "defense": 95,
        "speed": 70,
        "special": 70
      },
      "maxStats": {
        "maxHp": 384,
        "maxAtack": 295,
        "maxDefense": 317,
        "maxSpeed": 262,
      },
      "description": "Swims powerfully using all the muscles in its body. It can even overtake champion swimmers."
    },
    {
      "national_pokedex_number": 77,
      "name": "ponyta",
      "types": [
        "fire"
      ],
      "baseStats": {
        "hp": 50,
        "attack": 85,
        "defense": 55,
        "speed": 90,
        "special": 65
      },
      "maxStats": {
        "maxHp": 304,
        "maxAtack": 295,
        "maxDefense": 229,
        "maxSpeed": 306,
      },
      "description": "Capable of jumping incredibly high. Its hooves and sturdy legs absorb the impact of a hard landing."
    },
    {
      "national_pokedex_number": 137,
      "name": "porygon",
      "types": [
        "normal"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 60,
        "defense": 70,
        "speed": 40,
        "special": 75
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 240,
        "maxDefense": 262,
        "maxSpeed": 196,
      },
      "description": "A Pokémon that consists entirely of programming code. Capable of moving freely in cyberspace."
    },
    {
      "national_pokedex_number": 57,
      "name": "primeape",
      "types": [
        "fighting"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 105,
        "defense": 60,
        "speed": 95,
        "special": 60
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 339,
        "maxDefense": 240,
        "maxSpeed": 317,
      },
      "description": "It stops being angry only when nobody else is around. To view this moment is very difficult."
    },
    {
      "national_pokedex_number": 54,
      "name": "psyduck",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 50,
        "attack": 52,
        "defense": 48,
        "speed": 55,
        "special": 50
      },
      "maxStats": {
        "maxHp": 304,
        "maxAtack": 223,
        "maxDefense": 214,
        "maxSpeed": 229,
      },
      "description": "Always tormented by headaches. It uses psychic powers, but it is not known if it intends to do so."
    },
    {
      "national_pokedex_number": 26,
      "name": "raichu",
      "types": [
        "electric"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 90,
        "defense": 55,
        "speed": 100,
        "special": 90
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 306,
        "maxDefense": 229,
        "maxSpeed": 328,
      },
      "description": "When electricity builds up inside its body, it becomes feisty. It also glows in the dark."
    },
    {
      "national_pokedex_number": 78,
      "name": "rapidash",
      "types": [
        "fire"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 100,
        "defense": 70,
        "speed": 105,
        "special": 80
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 328,
        "maxDefense": 262,
        "maxSpeed": 339,
      },
      "description": "Just loves to run. If it sees something faster than itself, it will give chase at top speed."
    },
    {
      "national_pokedex_number": 20,
      "name": "raticate",
      "types": [
        "normal"
      ],
      "baseStats": {
        "hp": 55,
        "attack": 81,
        "defense": 60,
        "speed": 97,
        "special": 50
      },
      "maxStats": {
        "maxHp": 314,
        "maxAtack": 287,
        "maxDefense": 240,
        "maxSpeed": 322,
      },
      "description": "Its hind feet are webbed. They act as flippers, so it can swim in rivers and hunt for prey."
    },
    {
      "national_pokedex_number": 19,
      "name": "rattata",
      "types": [
        "normal"
      ],
      "baseStats": {
        "hp": 30,
        "attack": 56,
        "defense": 35,
        "speed": 72,
        "special": 25
      },
      "maxStats": {
        "maxHp": 264,
        "maxAtack": 232,
        "maxDefense": 185,
        "maxSpeed": 267,
      },
      "description": "Will chew on anything with its fangs. If you see one, it is certain that 40 more live in the area."
    },
    {
      "national_pokedex_number": 112,
      "name": "rhydon",
      "types": [
        "ground",
        "rock"
      ],
      "baseStats": {
        "hp": 105,
        "attack": 130,
        "defense": 120,
        "speed": 40,
        "special": 45
      },
      "maxStats": {
        "maxHp": 414,
        "maxAtack": 394,
        "maxDefense": 372,
        "maxSpeed": 196,
      },
      "description": "Walks on its hind legs. Shows signs of intelligence. Its armor-like hide even repels molten lava."
    },
    {
      "national_pokedex_number": 111,
      "name": "rhyhorn",
      "types": [
        "ground",
        "rock"
      ],
      "baseStats": {
        "hp": 80,
        "attack": 85,
        "defense": 95,
        "speed": 25,
        "special": 30
      },
      "maxStats": {
        "maxHp": 364,
        "maxAtack": 295,
        "maxDefense": 317,
        "maxSpeed": 163,
      },
      "description": "A Pokémon with a one-track mind. Once it charges, it won't stop running until it falls asleep."
    },
    {
      "national_pokedex_number": 27,
      "name": "sandshrew",
      "types": [
        "ground"
      ],
      "baseStats": {
        "hp": 50,
        "attack": 75,
        "defense": 85,
        "speed": 40,
        "special": 30
      },
      "maxStats": {
        "maxHp": 304,
        "maxAtack": 273,
        "maxDefense": 295,
        "maxSpeed": 196,
      },
      "description": "Its body is dry. When it gets cold at night, its hide is said to become coated with a fine dew."
    },
    {
      "national_pokedex_number": 28,
      "name": "sandslash",
      "types": [
        "ground"
      ],
      "baseStats": {
        "hp": 75,
        "attack": 100,
        "defense": 110,
        "speed": 65,
        "special": 55
      },
      "maxStats": {
        "maxHp": 354,
        "maxAtack": 328,
        "maxDefense": 350,
        "maxSpeed": 251,
      },
      "description": "It is skilled at slashing enemies with its claws. If broken, they start to grow back in a day."
    },
    {
      "national_pokedex_number": 123,
      "name": "scyther",
      "types": [
        "bug",
        "flying"
      ],
      "baseStats": {
        "hp": 70,
        "attack": 110,
        "defense": 80,
        "speed": 105,
        "special": 55
      },
      "maxStats": {
        "maxHp": 344,
        "maxAtack": 350,
        "maxDefense": 284,
        "maxSpeed": 339,
      },
      "description": "Leaps out of tall grass and slices prey with its scythes. The movement looks like that of a ninja."
    },
    {
      "national_pokedex_number": 117,
      "name": "seadra",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 55,
        "attack": 65,
        "defense": 95,
        "speed": 85,
        "special": 95
      },
      "maxStats": {
        "maxHp": 314,
        "maxAtack": 251,
        "maxDefense": 317,
        "maxSpeed": 295,
      },
      "description": "Touching the back fin causes numbness. It hooks its tail to coral to stay in place while sleeping."
    },
    {
      "national_pokedex_number": 119,
      "name": "seaking",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 80,
        "attack": 92,
        "defense": 65,
        "speed": 68,
        "special": 80
      },
      "maxStats": {
        "maxHp": 364,
        "maxAtack": 311,
        "maxDefense": 251,
        "maxSpeed": 258,
      },
      "description": "It is the male's job to make a nest by carving out boulders in a stream using the horn on its head."
    },
    {
      "national_pokedex_number": 86,
      "name": "seel",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 45,
        "defense": 55,
        "speed": 45,
        "special": 70
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 207,
        "maxDefense": 229,
        "maxSpeed": 207,
      },
      "description": "Loves freezing cold conditions. Relishes swimming in a frigid climate of around 14F degrees."
    },
    {
      "national_pokedex_number": 90,
      "name": "shellder",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 30,
        "attack": 65,
        "defense": 100,
        "speed": 40,
        "special": 45
      },
      "maxStats": {
        "maxHp": 264,
        "maxAtack": 251,
        "maxDefense": 328,
        "maxSpeed": 196,
      },
      "description": "The shell can withstand any attack. However, when it is open, the tender body is exposed."
    },
    {
      "national_pokedex_number": 80,
      "name": "slowbro",
      "types": [
        "water",
        "psychic"
      ],
      "baseStats": {
        "hp": 95,
        "attack": 75,
        "defense": 110,
        "speed": 30,
        "special": 80
      },
      "maxStats": {
        "maxHp": 394,
        "maxAtack": 273,
        "maxDefense": 350,
        "maxSpeed": 174,
      },
      "description": "Lives lazily by the sea. If the Shellder on its tail comes off, it becomes a Slowpoke again."
    },
    {
      "national_pokedex_number": 79,
      "name": "slowpoke",
      "types": [
        "water",
        "psychic"
      ],
      "baseStats": {
        "hp": 90,
        "attack": 65,
        "defense": 65,
        "speed": 15,
        "special": 40
      },
      "maxStats": {
        "maxHp": 384,
        "maxAtack": 251,
        "maxDefense": 251,
        "maxSpeed": 141,
      },
      "description": "Incredibly slow and sluggish. It is quite content to loll about without worrying about the time."
    },
    {
      "national_pokedex_number": 143,
      "name": "snorlax",
      "types": [
        "normal"
      ],
      "baseStats": {
        "hp": 160,
        "attack": 110,
        "defense": 65,
        "speed": 30,
        "special": 65
      },
      "maxStats": {
        "maxHp": 524,
        "maxAtack": 350,
        "maxDefense": 251,
        "maxSpeed": 174,
      },
      "description": "Will eat anything, even if the food happens to be a little moldy. It never gets an upset stomach."
    },
    {
      "national_pokedex_number": 21,
      "name": "spearow",
      "types": [
        "normal",
        "flying"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 60,
        "defense": 30,
        "speed": 70,
        "special": 31
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 240,
        "maxDefense": 174,
        "maxSpeed": 262,
      },
      "description": "Inept at flying high. However, it can fly around very fast to protect its territory."
    },
    {
      "national_pokedex_number": 7,
      "name": "squirtle",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 44,
        "attack": 48,
        "defense": 65,
        "speed": 43,
        "special": 50
      },
      "maxStats": {
        "maxHp": 292,
        "maxAtack": 214,
        "maxDefense": 251,
        "maxSpeed": 203,
      },
      "description": "Shoots water at prey while in the water. Withdraws into its shell when in danger."
    },
    {
      "national_pokedex_number": 121,
      "name": "starmie",
      "types": [
        "water",
        "psychic"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 75,
        "defense": 85,
        "speed": 115,
        "special": 100
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 273,
        "maxDefense": 295,
        "maxSpeed": 361,
      },
      "description": "The center section is named the core. People think it is communicating when it glows in 7 colors."
    },
    {
      "national_pokedex_number": 120,
      "name": "staryu",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 30,
        "attack": 45,
        "defense": 55,
        "speed": 85,
        "special": 70
      },
      "maxStats": {
        "maxHp": 264,
        "maxAtack": 207,
        "maxDefense": 229,
        "maxSpeed": 295,
      },
      "description": "As long as the center section is unharmed, it can grow back fully even if it is chopped to bits."
    },
    {
      "national_pokedex_number": 114,
      "name": "tangela",
      "types": [
        "grass"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 55,
        "defense": 115,
        "speed": 60,
        "special": 100
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 229,
        "maxDefense": 361,
        "maxSpeed": 240,
      },
      "description": "Its identity is obscured by masses of thick, blue vines. The vines are said to never stop growing."
    },
    {
      "national_pokedex_number": 128,
      "name": "tauros",
      "types": [
        "normal"
      ],
      "baseStats": {
        "hp": 75,
        "attack": 100,
        "defense": 95,
        "speed": 110,
        "special": 70
      },
      "maxStats": {
        "maxHp": 354,
        "maxAtack": 328,
        "maxDefense": 317,
        "maxSpeed": 350,
      },
      "description": "A rowdy Pokémon with a lot of stamina. Once running, it won't stop until it hits something."
    },
    {
      "national_pokedex_number": 72,
      "name": "tentacool",
      "types": [
        "water",
        "poison"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 40,
        "defense": 35,
        "speed": 70,
        "special": 100
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 196,
        "maxDefense": 185,
        "maxSpeed": 262,
      },
      "description": "It can sometimes be found all dry and shriveled up on a beach. Toss it back into the sea to revive it."
    },
    {
      "national_pokedex_number": 73,
      "name": "tentacruel",
      "types": [
        "water",
        "poison"
      ],
      "baseStats": {
        "hp": 80,
        "attack": 70,
        "defense": 65,
        "speed": 100,
        "special": 120
      },
      "maxStats": {
        "maxHp": 364,
        "maxAtack": 262,
        "maxDefense": 251,
        "maxSpeed": 328,
      },
      "description": "Its 80 tentacles can stretch and contract freely. They wrap around prey and weaken it with poison."
    },
    {
      "national_pokedex_number": 134,
      "name": "vaporeon",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 130,
        "attack": 65,
        "defense": 60,
        "speed": 65,
        "special": 110
      },
      "maxStats": {
        "maxHp": 464,
        "maxAtack": 251,
        "maxDefense": 240,
        "maxSpeed": 251,
      },
      "description": "Its cell structure is similar to water molecules. It will melt away and become invisible in water."
    },
    {
      "national_pokedex_number": 49,
      "name": "venomoth",
      "types": [
        "bug",
        "poison"
      ],
      "baseStats": {
        "hp": 70,
        "attack": 65,
        "defense": 60,
        "speed": 90,
        "special": 90
      },
      "maxStats": {
        "maxHp": 344,
        "maxAtack": 251,
        "maxDefense": 240,
        "maxSpeed": 306,
      },
      "description": "The powdery scales on its wings are hard to remove. They also contain poison that leaks out on contact."
    },
    {
      "national_pokedex_number": 48,
      "name": "venonat",
      "types": [
        "bug",
        "poison"
      ],
      "baseStats": {
        "hp": 60,
        "attack": 55,
        "defense": 50,
        "speed": 45,
        "special": 40
      },
      "maxStats": {
        "maxHp": 324,
        "maxAtack": 229,
        "maxDefense": 218,
        "maxSpeed": 207,
      },
      "description": "Its large eyes act as radars. In a bright place, you can see that they are clusters of many tiny eyes."
    },
    {
      "national_pokedex_number": 3,
      "name": "venusaur",
      "types": [
        "grass",
        "poison"
      ],
      "baseStats": {
        "hp": 80,
        "attack": 82,
        "defense": 83,
        "speed": 80,
        "special": 100
      },
      "maxStats": {
        "maxHp": 364,
        "maxAtack": 289,
        "maxDefense": 291,
        "maxSpeed": 284,
      },
      "description": "The flower on its back catches the sun's rays. The sunlight is then absorbed and used for energy."
    },
    {
      "national_pokedex_number": 71,
      "name": "victreebel",
      "types": [
        "grass",
        "poison"
      ],
      "baseStats": {
        "hp": 80,
        "attack": 105,
        "defense": 65,
        "speed": 70,
        "special": 100
      },
      "maxStats": {
        "maxHp": 364,
        "maxAtack": 339,
        "maxDefense": 251,
        "maxSpeed": 262,
      },
      "description": "Lures prey with the sweet aroma of honey. Swallowed whole, the prey is melted in a day, bones and all."
    },
    {
      "national_pokedex_number": 45,
      "name": "vileplume",
      "types": [
        "grass",
        "poison"
      ],
      "baseStats": {
        "hp": 75,
        "attack": 80,
        "defense": 85,
        "speed": 50,
        "special": 100
      },
      "maxStats": {
        "maxHp": 354,
        "maxAtack": 284,
        "maxDefense": 295,
        "maxSpeed": 218,
      },
      "description": "Flaps its broad flower petals to scatter its poisonous pollen. The flapping sound is very loud."
    },
    {
      "national_pokedex_number": 100,
      "name": "voltorb",
      "types": [
        "electric"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 30,
        "defense": 50,
        "speed": 100,
        "special": 55
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 174,
        "maxDefense": 218,
        "maxSpeed": 328,
      },
      "description": "It is said to camouflage itself as a Poké Ball. It will self-destruct with very little stimulus."
    },
    {
      "national_pokedex_number": 37,
      "name": "vulpix",
      "types": [
        "fire"
      ],
      "baseStats": {
        "hp": 38,
        "attack": 41,
        "defense": 40,
        "speed": 65,
        "special": 65
      },
      "maxStats": {
        "maxHp": 280,
        "maxAtack": 199,
        "maxDefense": 196,
        "maxSpeed": 251,
      },
      "description": "Both its fur and its tails are beautiful. As it grows, the tails split and form more tails."
    },
    {
      "national_pokedex_number": 8,
      "name": "wartortle",
      "types": [
        "water"
      ],
      "baseStats": {
        "hp": 59,
        "attack": 63,
        "defense": 80,
        "speed": 58,
        "special": 65
      },
      "maxStats": {
        "maxHp": 322,
        "maxAtack": 247,
        "maxDefense": 284,
        "maxSpeed": 236,
      },
      "description": "When tapped, this Pokémon will pull in its head, but its tail will still stick out a little bit."
    },
    {
      "national_pokedex_number": 13,
      "name": "weedle",
      "types": [
        "bug",
        "poison"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 35,
        "defense": 30,
        "speed": 50,
        "special": 20
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 185,
        "maxDefense": 174,
        "maxSpeed": 218,
      },
      "description": "Beware of the sharp stinger on its head. It hides in grass and bushes where it eats leaves."
    },
    {
      "national_pokedex_number": 70,
      "name": "weepinbell",
      "types": [
        "grass",
        "poison"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 90,
        "defense": 50,
        "speed": 55,
        "special": 85
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 306,
        "maxDefense": 218,
        "maxSpeed": 229,
      },
      "description": "When hungry, it swallows anything that moves. Its hapless prey is melted inside by strong acids."
    },
    {
      "national_pokedex_number": 110,
      "name": "weezing",
      "types": [
        "poison"
      ],
      "baseStats": {
        "hp": 65,
        "attack": 90,
        "defense": 120,
        "speed": 60,
        "special": 85
      },
      "maxStats": {
        "maxHp": 334,
        "maxAtack": 306,
        "maxDefense": 372,
        "maxSpeed": 240,
      },
      "description": "It lives and grows by absorbing dust, germs, and poison gases that are contained in toxic waste and garbage."
    },
    {
      "national_pokedex_number": 40,
      "name": "wigglytuff",
      "types": [
        "normal",
        "fairy"
      ],
      "baseStats": {
        "hp": 140,
        "attack": 70,
        "defense": 45,
        "speed": 45,
        "special": 50
      },
      "maxStats": {
        "maxHp": 484,
        "maxAtack": 262,
        "maxDefense": 207,
        "maxSpeed": 207,
      },
      "description": "Its body is full of elasticity. By inhaling deeply, it can continue to inflate itself without limit."
    },
    {
      "national_pokedex_number": 145,
      "name": "zapdos",
      "types": [
        "electric",
        "flying"
      ],
      "baseStats": {
        "hp": 90,
        "attack": 90,
        "defense": 85,
        "speed": 100,
        "special": 125
      },
      "maxStats": {
        "maxHp": 384,
        "maxAtack": 306,
        "maxDefense": 295,
        "maxSpeed": 328,
      },
      "description": "This legendary bird Pokémon is said to appear when the sky turns dark and lightning showers down."
    },
    {
      "national_pokedex_number": 41,
      "name": "zubat",
      "types": [
        "poison",
        "flying"
      ],
      "baseStats": {
        "hp": 40,
        "attack": 45,
        "defense": 35,
        "speed": 55,
        "special": 40
      },
      "maxStats": {
        "maxHp": 284,
        "maxAtack": 207,
        "maxDefense": 185,
        "maxSpeed": 229,
      },
      "description": "Emits ultrasonic cries while it flies. They act as a sonar used to check for objects in its way."
    }
  ]


    PokemonsArray.sort(function(a, b){return a.national_pokedex_number - b.national_pokedex_number});
    

  export default PokemonsArray;